export default __webpack_public_path__ + "static/media/indicator.6a8a4a9e.png";